<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="reasons"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.reasons_not_validation.description')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
            <v-list-item>
              <v-autocomplete
                :items="kind_of_donors"
                item-text="name"
                item-value="name"
                color="#086318"
                :label="$t('inputs.reasons_not_validation.kind_of_donor')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.kind_of_donor"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="reason_interviews"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <ReasonsNotFamilyInterview
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="closeDialog($event), loadGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getAllReasonNotFamilyInterview } from "@/service/basic-registrations/ReasonNotFamilyInterviewService";
import ReasonsNotFamilyInterview from "./ReasonsNotFamilyInterview.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import FormFieldsService from "@/service/FormFieldsService";

export default {
  components: {
    ReasonsNotFamilyInterview,
    Menu,
    ChangeStatus,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      filterForm: {},
      reasons: [],
      options: {},
      headers: [
        { text: "Descrição", align: "start", value: "description" },
        { text: "Tipo de Paciente", align: "start", value: "kind_of_donor.name" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 0,
      resource: {},
      kind_of_donors: [],
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "MotivoNaoCaptacaoForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
  },

  async mounted() {
    this.loadGridData();
    this.kind_of_donors = await FormFieldsService.getKindOfDonor();
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    loadGridData() {
      this.loading = true;
      getAllReasonNotFamilyInterview({
        description: this.filterForm.description ?? '',
        kind_of_donor: this.filterForm.kind_of_donor ?? '',
      }).then((result) => {
        this.loading = false;
        this.reasons = result;
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    closeDialog(item) {
      this.dialog = item;
      this.resource = {};
    },

    applyFilter() {
      this.loadGridData();
    },

    clearFilter() {
      this.filterForm = {};
      this.loadGridData();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
